/*
 * Konstanta symbolizující, že datasource načte všechna data v jedné dávce
 */
export const DATASOURCE_ALL_DATA = -1;
